<template>
    <div :class="['page campaign',{ off: !pageOn }]">
        <VHeader type="back" @back="back" />
        <div class="page-content reviews rating">
            <div v-for="review in reviews" class="review-listing" :key="review._id">
                <p><span><span v-for="item in new Array(review.rating).fill(0)" :style="{ 'background-image': 'url('+fullStar+')' }"></span></span>{{ review.name }}<span>{{ review.when }}</span></p>
                <p v-if="review.likes > 0" style="text-align: right;">Likes: {{ review.likes }}</p>
                <p>{{ review.review }}</p>
                <div v-if="review.reply"  class="review-reply">
                    <p>{{ review.replyFrom }}<span>{{ review.replyWhen }}</span></p>
                    <p>{{ review.reply }}</p>
                </div>
                <div v-if="review.replying">
                    <div class="label" style="display:none">
                        <p>From</p>
                        <input v-model="review.replying.from" />
                    </div>
                    <div class="label">
                        <p>Reply</p>
                        <textarea v-model="review.replying.reply"></textarea>
                    </div>
                </div>
                <div v-if="!review.posted">
                    <div v-if="!review.replying">
                        <p class="btn" @click="postResponse(review)" style="width: calc(50% - 30px);background-color: #93C11F;">post</p>
                        <p class="btn" @click="review.replying = { from: review.replyFrom || '', reply: review.reply || '' }" style="width: calc(50% - 30px)">reply</p>
                    </div>
                    <div v-if="review.replying">
                        <p @click="cancelReply(review)" class="btn" style="width: calc(50% - 30px)">cancel</p>
                        <p @click="sendReply(review)" class="btn" style="width:calc(50% - 30px)">save</p>
                    </div>
                </div>
                <div v-if="review.posted">
                    
                    <div v-if="!review.replying">
                        <p class="btn" @click="unPostResponse(review)" style="background-color: #C03148;width: calc(50% - 30px)">un-post</p>
                        <p class="btn" @click="review.replying = { from: review.replyFrom || '', reply: review.reply || '' }" style="width: calc(50% - 30px)">reply</p>
                    </div>
                    <div v-if="review.replying">
                        <p @click="cancelReply(review)" class="btn" style="width: calc(50% - 30px)">cancel</p>
                        <p @click="sendReply(review)" class="btn" style="width:calc(50% - 30px)">save</p>
                    </div>
                </div>
            </div>
            <div v-if="end"><p style="float: left;margin:30px 0px;text-align: center;width: 100%;font-size: 30px;">END OF REVIEWS</p></div>
            <div v-if="waiting" style="position: relative;transform: scale(1.5);left:50%;margin: 20px 0px 20px -20px;float: left;">
                <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                            <stop stop-color="#fff" stop-opacity="0" offset="0%"/>
                            <stop stop-color="#fff" stop-opacity=".631" offset="63.146%"/>
                            <stop stop-color="#fff" offset="100%"/>
                        </linearGradient>
                    </defs>
                    <g fill="none" fill-rule="evenodd">
                        <g transform="translate(1 1)">
                            <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2">
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 18 18"
                                    to="360 18 18"
                                    dur="0.9s"
                                    repeatCount="indefinite" />
                            </path>
                            <circle fill="#fff" cx="36" cy="18" r="1">
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 18 18"
                                    to="360 18 18"
                                    dur="0.9s"
                                    repeatCount="indefinite" />
                            </circle>
                        </g>
                    </g>
                </svg>
            </div>
        </div>  
        
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { mapMutations } from 'vuex'
import { pageOn } from '@/utils/pageOn.js'
import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'

export default {
    props: ['campaign'],
    name: 'reviews',
    components: {
        VHeader,
    },
    mixins: [ pageOn ],
    computed: {
        auth () { return this.$store.state.auth },
        pages () { return this.$store.state.pages },
        clientCampaigns () { return this.$store.state.clientCampaigns }
    },
    data () {
        return {
            reviews: [],
            skip: 0,
            limit: 6,
            available: 0,
            campaign_id: '',
            fullStar: '',
            end: false,
            waiting: false,
            gettingReviews: false
        }
    },
    mounted () {
        this.campaign_id = this.campaign._id;
        this.fullStar = 'https://img.netframe.io/happier/img-5ee3971d568a8574c92c4a27.png'; //this.campaign.stars['s-fullStar'];
        this.getReviews();
        this.gettingReviews = false;
        var scroller = this.$el.querySelector('.page-content.reviews');
            scroller.onscroll = () => {
                var container = this.$el.querySelector('.page-content.reviews .review-listing:last-child');
                if ( !container ) return;
                var height = container.offsetTop;
                if ( !this.end && !this.gettingReviews && scroller.scrollTop / height > 0.5 ) { this.gettingReviews = true; this.getReviews(); }
            }        
    },
    methods: {
        update ( review, update ) {
            console.log('review._id',review._id);
            WebSoc.SEND({ t: 'updateReview', data: { auth: this.auth, campaign_id: this.campaign_id, review_id: review._id, update }},() => {})
        },
        postResponse ( review ) {
            review.posted = true;
            this.update(review,{ posted: true })
        },
        unPostResponse ( review ) {
            review.posted = false;
            this.update(review,{ posted: false });
        },
        suspendResponse ( review ) {
            Alert.yesno('Suspend Review ?',yes => {
                if ( !yes ) return;
                review.suspended = true;
                this.update(review,{ suspended: true });
            })
            
        },
        restoreSuspended ( review ) {
            Alert.yesno('Restore Review',yes => {
                if ( !yes ) return;
                review.suspended = false;
                this.update(review,{ suspended: false });
            });
        },
        sendReply ( review ) {
            review.reply = review.replying.reply;
            review.replyFrom = review.replying.from;
            review.replyWhen = 'Just Now';
            this.update(review,{ reply: review.reply, replyFrom: review.replyFrom, replyWhen: Date.now() })
            review.replying = false;
        },
        cancelReply ( review ) {
            review.replying = false;
            /*
            Alert.yesno('Cancel this reply ?',yes => {
                if ( !yes ) return;
                
            })
            */
        },
        getReviews () {
            console.log('getReviews');
            this.waiting = true;
            var { campaign_id, skip, limit } = this;
            WebSoc.SEND({ t: 'getReviews', data: { auth: this.auth, campaign_id, skip, limit, ratingSummary: this.campaign.ratingSummary, orderby: 'date', seq: -1 } },resp => {
                console.log({
                    skip,
                    reviews: resp.reviews
                });
                this.waiting = false;
                this.gettingReviews = false;
                resp.reviews.forEach(review => { review.replying = false; review.posted = review.posted || false });
                console.log(JSON.parse(JSON.stringify(resp.reviews)));
                if ( resp.reviews.length < limit ) { this.end = true; }
                this.reviews = this.reviews.concat(resp.reviews);
                this.skip += limit;
            })
        },
        back () {
            this.pageOn = false;
            setTimeout(() => {
               this.popPage('review');
            },200);
        },
        ...mapMutations(['pushPage','popPage'])
    }
}

</script>

<style lang="scss">
.label {
    textarea {
        width: calc(100% - 40px);
        margin: 0px 15px;
        min-height: 140px;
    }
}    
.campaign .reviews {
    .label {
        input,textarea { width: calc(100% - 50px); padding: 5px 10px; font-size:20px; }
    }
    .review-reply {
        float: left;
        border: 1px solid #c0c0c0;
        width: calc(100% - 20px);
        margin: 10px;
        p { width: calc(100% - 30px); float: left; }
        p:nth-child(1) { width: calc(100% - 30px); span { float: right; text-align: right; } }
       
    }
    .review-listing {
        border: 1px solid #c0c0c0;
        float: left;
        width: calc(100% - 20px);
        margin: 10px;
        
        > p:nth-child(1) {
            float: left;
            width: calc(100% - 30px);
            > span { width: 110px; float: left; > span { background-size: contain; width: 20px; height: 20px; float: left; } }
            > span:last-child { float: right; text-align: right; width: auto; }
        }
        > p:nth-child(2) { float: left; margin: 15px 10px; width: calc(100% - 20px); line-height: 1.4; }
        .btn { float: left; width: calc(100% - 30px); }
    }
}
</style>